const SCREEN_SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};
const TYPOGRAPHY_SIZE = {
  GIGANTIC: 'gigantic',
  HUGE: 'huge',
  LARGE: 'large',
  BIGGER: 'bigger',
  BIG: 'big',
  NORMAL: 'normal'
};
const COLORS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DARK_GREY: 'darkGrey',
  GREY: 'grey',
  LIGHT_GREY: 'lightGrey',
  BLACK: 'black',
  WHITE: 'white'
};
const BOX_SHADOW_TYPES_VALUES = {
  LOW: 'LOW',
  HIGH: 'HIGH',
  NONE: 'NONE'
};
const BOOLEAN_VALUES = {
  FALSE: false,
  TRUE: true
};
const ALIGNMENT_OPTIONS = {
  CENTER: 'CENTER',
  START: 'START'
};
const SEMANTIC_TAG_VALUES = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  P: 'p',
  SPAN: 'span'
};
const CONFIGURATION_TYPES = {
  COLOR: 'COLOR',
  TYPOGRAPHY: 'TYPOGRAPHY',
  NUMBER: 'NUMBER',
  BOX_SHADOW: 'BOX_SHADOW',
  BOOLEAN: 'BOOLEAN',
  ALIGNMENT: 'ALIGNMENT',
  RATIO: 'RATIO',
  SEMANTIC_TAG: 'SEMANTIC_TAG'
};

const baseConfiguration = {
  onTopCard: [{
    name: 'cardTitleColorTypeNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeHover',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeNormal',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeHover',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeActive',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColorTypeNormal',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'aspectRatioLarge',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioMedium',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'overlayColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleAlignment',
    value: ALIGNMENT_OPTIONS.START,
    type: CONFIGURATION_TYPES.ALIGNMENT
  }, {
    name: 'showDate',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'dateFontSizeLarge',
    value: TYPOGRAPHY_SIZE.HUGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'dateFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'dateFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'dateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'pipeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showAuthorInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'authorAlignment',
    value: ALIGNMENT_OPTIONS.START,
    type: CONFIGURATION_TYPES.ALIGNMENT
  }, {
    name: 'authorSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'authorFontSizeLarge',
    value: TYPOGRAPHY_SIZE.HUGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'wrapperGapLarge',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapMedium',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapSmall',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H3,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'dateSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }],
  verticalCard: [{
    name: 'cardBackgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeNormal',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeHover',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeActive',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'borderWidthTypeNormal',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeHover',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeActive',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColorTypeNormal',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showAuthorInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'authorSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'authorFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'aspectRatioLarge',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioMedium',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H3,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'showDate',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'dateFontSizeLarge',
    value: TYPOGRAPHY_SIZE.HUGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'dateFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'dateFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'dateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'pipeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'wrapperGapLarge',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapMedium',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapSmall',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  horizontalCard: [{
    name: 'cardBackgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeNormal',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeHover',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeActive',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'borderWidthTypeNormal',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeHover',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeActive',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColorTypeNormal',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'aspectRatioLarge',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioMedium',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'shouldReverseImageAlignment',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H3,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'showDate',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'dateFontSizeLarge',
    value: TYPOGRAPHY_SIZE.HUGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'dateFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'dateFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'dateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'pipeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showAuthorInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'authorSemanticTag',
    value: SEMANTIC_TAG_VALUES.H5,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'authorFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'wrapperGapLarge',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapMedium',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapSmall',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapLarge',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapMedium',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapMedium',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'cardProportionsLarge',
    value: {
      x: 1,
      y: 2
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'cardProportionsMedium',
    value: {
      x: 1,
      y: 2
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'cardProportionsSmall',
    value: {
      x: 1,
      y: 2
    },
    type: CONFIGURATION_TYPES.RATIO
  }],
  decorationLine: [{
    name: 'cardDecorationColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  sectionHeader: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'idleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'visitedStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  listWithHeading: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderWidth',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  list: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderWidth',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  listItem: [{
    name: 'borderColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkHoverColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  button: [{
    name: 'backgroundColorEnabled',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorEnabled',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorDisabled',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 32,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeDisable',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  main: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  mainPostPage: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  primaryHeader: [{
    name: 'backgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  primaryLinks: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'visitedStateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeBorderBottom',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverOtherLinksColors',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  editions: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  editionsMenu: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'menuBackgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  ctaButton: [{
    name: 'backgroundColorNormal',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorHover',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  footer: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderTopColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'separatorColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  footerLinksSection: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'visitedStateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  footerMobileStores: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  secondaryHeader: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  secondaryLink: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverOtherLinksColors',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  moreLinks: [{
    name: 'titleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'menuBackgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  menuIcon: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  ampCloseMenuIcon: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  menuLinks: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'dividerColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  menuLink: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  menuSubLink: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  footerSocialLinks: [{
    name: 'titleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'circleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  bottomFooterBar: [{
    name: 'backgroundColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  errorPage: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'buttonColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'buttonBackgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  articleTitle: [{
    name: 'titleColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'metaDataColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  imageWithFigcaptionWrapper: [{
    name: 'figcaptionTextColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  imageWrapper: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  articleParagraph: [{
    name: 'linkColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  quote: [{
    name: 'borderColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'citeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'iconColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  divider: [{
    name: 'color',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  mmPlayer: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  iframeEmbed: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  iframe: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  postMainContent: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  streamable: [{
    name: 'backgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }],
  listItemTitle: [{
    name: 'titleColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'numberColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  articleShareButton: [{
    name: 'buttonBackgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'buttonHoverColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  copyLinkButton: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  playIcon: [{
    name: 'fillColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'lineColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  mobileTopBar: [{
    name: 'backgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }],
  postRecommendationsHeader: [{
    name: 'color',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  recommendationCardPlaceHolder: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  sponsor: [{
    name: 'dividerColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  authorPage: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'metaDataColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'color',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  authorImage: [{
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  authorPageSocial: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  authorTopGradient: [{
    name: 'color',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  oneTwoOnTopFullWidth: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  twoOneTwoArticleList: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'minorCardsRatioLarge',
    value: {
      x: 1,
      y: 1
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'minorCardsRatioMedium',
    value: {
      x: 1,
      y: 1
    },
    type: CONFIGURATION_TYPES.RATIO
  }],
  oneThreeOTC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  twoTwoVC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  threeThreeVC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  sixHC: [{
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  fourVC: [{
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  sixHC_FourVC: [{
    name: 'largeVerticalSeparatorGap',
    value: 1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalSeparatorGap',
    value: 1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalSeparatorGap',
    value: 1,
    type: CONFIGURATION_TYPES.NUMBER
  }]
};

class ConfigurationBuilder {
  // eslint-disable-next-line no-useless-constructor,no-empty-function
  constructor(overrides = { ...baseConfiguration
  }) {
    this.overrides = overrides;
  }

  replaceValueInElement(componentName, propName, value) {
    return this.overrides[componentName].map(element => {
      if (element.name === propName) {
        return { ...element,
          value
        };
      }

      return element;
    });
  }

  overrideColor(componentName, propName, color) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, color);
    return this;
  }

  overrideNumber(componentName, propName, number) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, number);
    return this;
  }

  overrideBoxShadow(componentName, propName, boxShadow) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, boxShadow);
    return this;
  }

  overrideBoolean(componentName, propName, boolean) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, boolean);
    return this;
  }

  build() {
    return { ...this.overrides
    };
  }

}

const configurationBuilder = () => new ConfigurationBuilder();

const configuration = configurationBuilder().overrideColor('verticalCard', 'cardTextColorTypeNormal', 'primary').overrideColor('verticalCard', 'cardTextColorTypeHover', 'primary').overrideColor('verticalCard', 'cardTextColorTypeActive', 'primary').overrideColor('horizontalCard', 'cardTextColorTypeNormal', 'primary').overrideColor('horizontalCard', 'cardTextColorTypeHover', 'primary').overrideColor('horizontalCard', 'cardTextColorTypeActive', 'primary').overrideColor('onTopCard', 'overlayColor', 'black').overrideColor('decorationLine', 'cardDecorationColor', 'primary').overrideColor('sectionHeader', 'titleColor', 'secondary').overrideColor('sectionHeader', 'idleColor', 'secondary').overrideColor('sectionHeader', 'hoverStateColor', 'secondary').overrideColor('sectionHeader', 'activeStateColor', 'secondary').overrideColor('listWithHeading', 'titleColor', 'secondary').overrideColor('listItem', 'linkColor', 'primary').overrideColor('listItem', 'linkHoverColor', 'secondary').overrideColor('primaryHeader', 'backgroundColor', 'primary').overrideColor('primaryLinks', 'hoverStateColor', 'white').overrideColor('primaryLinks', 'activeStateColor', 'white').overrideColor('primaryLinks', 'activeBorderBottom', 'white').overrideColor('primaryLinks', 'hoverOtherLinksColors', 'grey').overrideColor('editionsMenu', 'menuBackgroundColor', 'primary').overrideColor('footer', 'separatorColor', 'primary').overrideColor('secondaryLink', 'hoverStateColor', 'white').overrideColor('secondaryLink', 'hoverOtherLinksColors', 'grey').overrideColor('moreLinks', 'hoverColor', 'white').overrideColor('mobileTopBar', 'backgroundColor', 'primary').build();

const colors = {
  [COLORS.PRIMARY]: '#1493FF',
  [COLORS.SECONDARY]: '#1F375B',
  [COLORS.DARK_GREY]: '#445058',
  [COLORS.GREY]: '#B9C4CB',
  [COLORS.LIGHT_GREY]: '#F0F3F8',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts = [{
  provider: 'custom',
  family: 'proxima-nova',
  variants: ['400', '600', '700'],
  stylesheetUrl: 'https://use.typekit.net/nxl2plh.css'
}];

const fontSizeMap = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  }
};

const palette = {
  colors,
  fonts,
  fontSizeMap
};

const configuration$1 = configurationBuilder().overrideNumber('onTopCard', 'borderWidthTypeNormal', 2).overrideNumber('onTopCard', 'borderWidthTypeHover', 2).overrideNumber('onTopCard', 'borderWidthTypeActive', 2).overrideNumber('verticalCard', 'borderWidthTypeNormal', 2).overrideNumber('verticalCard', 'borderWidthTypeHover', 2).overrideNumber('horizontalCard', 'borderWidthTypeNormal', 2).overrideNumber('horizontalCard', 'borderWidthTypeHover', 2).overrideNumber('horizontalCard', 'borderWidthTypeActive', 2).overrideNumber('list', 'borderWidth', 2).overrideNumber('listWithHeading', 'borderWidth', 2).overrideColor('list', 'borderColor', COLORS.LIGHT_GREY).overrideColor('listWithHeading', 'borderColor', COLORS.LIGHT_GREY).overrideColor('horizontalCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('horizontalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('horizontalCard', 'borderColorTypeActive', COLORS.LIGHT_GREY).overrideColor('verticalCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('verticalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('verticalCard', 'borderColorTypeActive', COLORS.LIGHT_GREY).overrideColor('onTopCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('onTopCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('onTopCard', 'borderColorTypeActive', COLORS.LIGHT_GREY).overrideColor('decorationLine', 'cardDecorationColor', COLORS.WHITE).overrideColor('main', 'backgroundColor', COLORS.WHITE).overrideColor('verticalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideColor('horizontalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideColor('horizontalCard', 'cardTextColorTypeActive', COLORS.DARK_GREY).overrideBoxShadow('onTopCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).build();

const colors$1 = {
  [COLORS.PRIMARY]: '#FF9900',
  [COLORS.SECONDARY]: '#1B1B1B',
  [COLORS.DARK_GREY]: '#444444',
  [COLORS.GREY]: '#A1A1A1',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$1 = [{
  provider: 'google',
  family: 'Roboto',
  variants: ['400', '600', '700']
}];

const fontSizeMap$1 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$1 = {
  colors: colors$1,
  fonts: fonts$1,
  fontSizeMap: fontSizeMap$1
};

const configuration$2 = configurationBuilder().overrideColor('primaryHeader', 'backgroundColor', 'primary').overrideColor('primaryLinks', 'hoverStateColor', 'grey').overrideColor('primaryLinks', 'activeStateColor', 'white').overrideColor('primaryLinks', 'activeBorderBottom', 'white').overrideColor('footer', 'separatorColor', 'primary').overrideColor('secondaryLink', 'hoverStateColor', 'grey').overrideColor('secondaryLink', 'activeStateColor', 'white').overrideColor('bottomFooterBar', 'backgroundColor', 'primary').overrideColor('mobileTopBar', 'backgroundColor', 'primary').build();

const colors$2 = {
  [COLORS.PRIMARY]: '#6A1B9A',
  [COLORS.SECONDARY]: '#38006B',
  [COLORS.DARK_GREY]: '#445058',
  [COLORS.GREY]: '#9E9E9E',
  [COLORS.LIGHT_GREY]: '#F5F5F5',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$2 = [{
  provider: 'google',
  family: 'Roboto',
  variants: ['400', '600', '700']
}];

const fontSizeMap$2 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$2 = {
  colors: colors$2,
  fonts: fonts$2,
  fontSizeMap: fontSizeMap$2
};

const configuration$3 = configurationBuilder().overrideColor('moreLinks', 'hoverColor', 'grey').overrideColor('moreLinks', 'activeColor', 'secondary').overrideColor('menuIcon', 'color', 'primary').overrideColor('menuLinks', 'backgroundColor', 'black').overrideColor('menuLink', 'activeStateColor', 'secondary').overrideColor('footerSocialLinks', 'circleColor', 'secondary').overrideColor('bottomFooterBar', 'backgroundColor', 'black').overrideColor('articleTitle', 'titleColor', 'primary').overrideColor('mobileTopBar', 'backgroundColor', 'primary').overrideColor('primaryHeader', 'backgroundColor', 'white').overrideColor('secondaryHeader', 'backgroundColor', 'darkGrey').overrideColor('primaryLinks', 'idleColor', 'darkGrey').overrideColor('primaryLinks', 'visitedStateColor', 'darkGrey').overrideColor('primaryLinks', 'hoverOtherLinksColors', 'darkGrey').overrideColor('secondaryLink', 'hoverStateColor', 'secondary').overrideColor('secondaryLink', 'activeStateColor', 'secondary').overrideColor('secondaryLink', 'hoverOtherLinksColors', 'lightGrey').overrideColor('moreLinks', 'menuBackgroundColor', 'darkGrey').overrideColor('moreLinks', 'hoverColor', 'secondary').overrideColor('editions', 'color', 'darkGrey').overrideColor('editionsMenu', 'color', 'darkGrey').overrideColor('editionsMenu', 'menuBackgroundColor', 'white').overrideColor('editionsMenu', 'hoverColor', 'primary').overrideColor('editionsMenu', 'linkColor', 'darkGrey').overrideColor('editionsMenu', 'activeColor', 'primary').overrideColor('footer', 'backgroundColor', 'darkGrey').overrideColor('footer', 'borderTopColor', 'secondary').overrideColor('footer', 'separatorColor', 'secondary').overrideColor('footerLinksSection', 'hoverStateColor', 'secondary').overrideColor('decorationLine', 'cardDecorationColor', 'secondary').overrideColor('articleShareButton', 'buttonBackgroundColor', 'secondary').overrideNumber('onTopCard', 'borderRadius', 0).overrideNumber('verticalCard', 'borderRadius', 0).overrideNumber('horizontalCard', 'borderRadius', 0).overrideNumber('ctaButton', 'borderRadius', 0).overrideNumber('list', 'borderRadius', 0).overrideNumber('listWithHeading', 'borderRadius', 0).overrideColor('onTopCard', 'overlayColor', 'black').build();

const colors$3 = {
  [COLORS.PRIMARY]: '#020286',
  [COLORS.SECONDARY]: '#1CB1E5',
  [COLORS.DARK_GREY]: '#212121',
  [COLORS.GREY]: '#9E9E9E',
  [COLORS.LIGHT_GREY]: '#F5F5F5',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$3 = [{
  provider: 'google',
  family: 'Montserrat',
  variants: ['600', '700']
}, {
  provider: 'google',
  family: 'Roboto Slab',
  variants: ['400']
}];

const fontSizeMap$3 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Roboto Slab',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$3 = {
  colors: colors$3,
  fonts: fonts$3,
  fontSizeMap: fontSizeMap$3
};

const configuration$4 = configurationBuilder().overrideColor('onTopCard', 'overlayColor', 'black').overrideColor('editionsMenu', 'menuBackgroundColor', 'black').overrideColor('footer', 'backgroundColor', 'darkGrey').overrideColor('footer', 'separatorColor', 'primary').overrideColor('secondaryHeader', 'backgroundColor', 'darkGrey').overrideColor('moreLinks', 'menuBackgroundColor', 'darkGrey').overrideColor('bottomFooterBar', 'backgroundColor', 'black').overrideColor('editionsMenu', 'hoverColor', 'primary').overrideColor('menuLinks', 'backgroundColor', 'black').overrideNumber('onTopCard', 'borderRadius', 0).overrideNumber('verticalCard', 'borderRadius', 0).overrideNumber('horizontalCard', 'borderRadius', 0).overrideNumber('ctaButton', 'borderRadius', 0).overrideNumber('list', 'borderRadius', 0).overrideNumber('listWithHeading', 'borderRadius', 0).build();

const colors$4 = {
  [COLORS.PRIMARY]: '#DC2330',
  [COLORS.SECONDARY]: '#71CDDD',
  [COLORS.DARK_GREY]: '#212121',
  [COLORS.GREY]: '#A1A1A1',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$4 = [{
  provider: 'google',
  family: 'Oswald',
  variants: ['400', '600', '700']
}, {
  provider: 'google',
  family: 'Barlow',
  variants: ['400', '600', '700']
}];

const fontSizeMap$4 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 600,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 400,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'Barlow',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Barlow',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$4 = {
  colors: colors$4,
  fonts: fonts$4,
  fontSizeMap: fontSizeMap$4
};

const configuration$5 = configurationBuilder().overrideNumber('onTopCard', 'borderWidthTypeNormal', 0).overrideNumber('onTopCard', 'borderWidthTypeHover', 2).overrideNumber('onTopCard', 'borderWidthTypeActive', 0).overrideColor('onTopCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideNumber('verticalCard', 'borderWidthTypeNormal', 0).overrideNumber('verticalCard', 'borderWidthTypeHover', 2).overrideNumber('verticalCard', 'borderWidthTypeActive', 0).overrideColor('verticalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideNumber('horizontalCard', 'borderWidthTypeNormal', 0).overrideNumber('horizontalCard', 'borderWidthTypeHover', 2).overrideNumber('horizontalCard', 'borderWidthTypeActive', 0).overrideColor('horizontalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('decorationLine', 'cardDecorationColor', COLORS.WHITE).overrideColor('verticalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideColor('horizontalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideBoxShadow('onTopCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).build();

const colors$5 = {
  [COLORS.PRIMARY]: '#75CEDC',
  [COLORS.SECONDARY]: '#1B1B1B',
  [COLORS.DARK_GREY]: '#444444',
  [COLORS.GREY]: '#A1A1A1',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$5 = [{
  provider: 'custom',
  family: 'itc-avant-garde-gothic-pro',
  variants: ['300', '500', '700'],
  stylesheetUrl: 'https://use.typekit.net/mrl0ift.css'
}, {
  provider: 'custom',
  family: 'europa',
  variants: ['400', '500', '700'],
  stylesheetUrl: 'https://use.typekit.net/cew3eqg.css'
}];

const fontSizeMap$5 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 500,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 500,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 500,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 300,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 300,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'europa',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$5 = {
  colors: colors$5,
  fonts: fonts$5,
  fontSizeMap: fontSizeMap$5
};

const configuration$6 = configurationBuilder().overrideColor('onTopCard', 'overlayColor', 'black').overrideColor('editionsMenu', 'menuBackgroundColor', 'black').overrideColor('footer', 'backgroundColor', 'darkGrey').overrideColor('footer', 'separatorColor', 'primary').overrideColor('primaryHeader', 'backgroundColor', 'primary').overrideColor('secondaryHeader', 'backgroundColor', 'darkGrey').overrideColor('moreLinks', 'menuBackgroundColor', 'darkGrey').overrideColor('bottomFooterBar', 'backgroundColor', 'black').overrideColor('editionsMenu', 'hoverColor', 'primary').overrideColor('menuLinks', 'backgroundColor', 'black').overrideColor('listItem', 'borderColor', 'primary').overrideNumber('onTopCard', 'borderRadius', 0).overrideNumber('verticalCard', 'borderRadius', 0).overrideNumber('horizontalCard', 'borderRadius', 0).overrideNumber('ctaButton', 'borderRadius', 0).overrideNumber('list', 'borderRadius', 0).build();

const colors$6 = {
  [COLORS.PRIMARY]: '#BDA55C',
  [COLORS.SECONDARY]: '#1F1B1B',
  [COLORS.DARK_GREY]: '#212121',
  [COLORS.GREY]: '#9E9E9E',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$6 = [{
  provider: 'custom',
  family: 'kulturista-web',
  variants: ['600', '700'],
  stylesheetUrl: 'https://use.typekit.net/jps0ikq.css'
}, {
  provider: 'google',
  family: 'Open Sans',
  variants: ['400']
}];

const fontSizeMap$6 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Open Sans',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$6 = {
  colors: colors$6,
  fonts: fonts$6,
  fontSizeMap: fontSizeMap$6
};

const themeByKey = {
  orangeAndBlack: {
    configuration: configuration$1,
    palette: palette$1
  },
  blueAndGrey: {
    configuration: configuration,
    palette: palette
  },
  purpleAndViolet: {
    configuration: configuration$2,
    palette: palette$2
  },
  thebiglead: {
    configuration: configuration$3,
    palette: palette$3
  },
  dbltap: {
    configuration: configuration$4,
    palette: palette$4
  },
  floor8: {
    configuration: configuration$5,
    palette: palette$5
  },
  laVida: {
    configuration: configuration$6,
    palette: palette$6
  }
};

const createTheme = themeKey => {
  if (!themeByKey[themeKey]) {
    throw new Error(`${themeKey} is not a valid themeKey`);
  }

  const {
    configuration,
    palette
  } = themeByKey[themeKey];
  return {
    palette,
    configuration
  };
};

const getThemeByKey = themeKey => {
  return createTheme(themeKey);
};

export { COLORS, CONFIGURATION_TYPES, getThemeByKey };
//# sourceMappingURL=index.bundle.esm.js.map
